import { render, staticRenderFns } from "./TokenAdd.vue?vue&type=template&id=185b7691"
import script from "./TokenAdd.vue?vue&type=script&lang=js"
export * from "./TokenAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports